import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=f7f60470&scoped=true&"
import script from "./DepositDialog.vue?vue&type=script&lang=ts&"
export * from "./DepositDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DepositDialog.vue?vue&type=style&index=0&id=f7f60470&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f60470",
  null
  
)

export default component.exports